import { IFavoritesFolder } from '../../types/favoriteEntity';
import { IApplicationState } from '../../types/redux';

export const selectSelectedFolder = (state: IApplicationState): IFavoritesFolder | null => {
  const selectedId = state.folders.selectedId;
  if (!selectedId) {
    return null;
  }

  const selectedFolders = state.folders.list.filter(folder => folder.id === selectedId);

  return selectedFolders.length ? selectedFolders[0] : null;
};
